import React from "react";
import { useField } from "formik";
import ReactSwitch from "react-switch";
import styled from "@emotion/styled";

const Switch = (props) => {
  const { subLabel , disabled } = props;
  const [field, meta, helper] = useField({
    name: props.name,
    type: "checkbox",
  });
  const { value } = field;
  const { setValue } = helper;

  const handleChange = (checked) => {
    setValue(checked);
  };

  return (
    <>
      <ReactSwitch
      disabled={disabled}
        width={65}
        uncheckedIcon={<Label>{subLabel}</Label>}
        checkedIcon={<Label>{subLabel}</Label>}
        onChange={handleChange}
        checked={value ? true : false}
      />
    </>
  );
};

const Label = styled.span`
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  text-transform: capitalize;
`;

export default Switch;
